import { render, staticRenderFns } from "./storeAdmin.vue?vue&type=template&id=33ef969b&scoped=true&"
import script from "./storeAdmin.vue?vue&type=script&lang=js&"
export * from "./storeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./storeAdmin.vue?vue&type=style&index=0&id=33ef969b&scoped=scoped&lang=css&"
import style1 from "./storeAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef969b",
  null
  
)

export default component.exports